import React from 'react';
import PropTypes from 'prop-types';

import { Decline } from 'components/Icons';
import useWorkflowGuard from 'hooks/useWorkflowGuard';

const Declined = ({ navigate, searchParams }) => {
  useWorkflowGuard(searchParams, navigate);

  return (
    <div className="flex flex-col items-center text-center mb-8">
      <Decline className="mb-4" />
      <p className="text-xl md:text-3xl font-semibold text-slate-800 mb-8">
        Unfortunately, your <br/>application was not <br/>approved at this time.
      </p>

      <p className="text-sm md:text-base text-gray-600 px-0 md:px-[115px] ">
        You will receive an adverse action notice within <span className="font-bold">30 days</span> that will provide you with specific reason(s) as to why your application was not approved.
      </p>
    </div>
  );
};

Declined.propTypes = {
  navigate: PropTypes.func.isRequired,
  searchParams: PropTypes.object.isRequired,
};

export default Declined;
